module.exports = __webpack_public_path__ + "img/btn-announce-disable.17ef4705.svg";